import React from "react";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import Image from "~components/atoms/image/image";
import { MEDIA } from "../../../prop_types";
import * as classes from "./caption_image.module.scss";

export default function CaptionImage({ image: [image], caption, ...rest }) {
  if (image) {
    return (
      <SbEditable content={rest}>
        <div className={classes.captionImage}>
          <Image {...image} />
          {caption && <p className={classes.caption}>{caption}</p>}
        </div>
      </SbEditable>
    );
  }

  return null;
}

CaptionImage.defaultProps = {
  image: null,
  caption: "",
};

CaptionImage.propTypes = {
  image: MEDIA,
  caption: PropTypes.string,
};
